export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9560.2ff169ce.jpg";